import { render, staticRenderFns } from "./RolesPermissions.vue?vue&type=template&id=7b6790f2&"
import script from "./RolesPermissions.vue?vue&type=script&lang=js&"
export * from "./RolesPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6790f2')) {
      api.createRecord('7b6790f2', component.options)
    } else {
      api.reload('7b6790f2', component.options)
    }
    module.hot.accept("./RolesPermissions.vue?vue&type=template&id=7b6790f2&", function () {
      api.rerender('7b6790f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/RolesPermissions.vue"
export default component.exports